import BaseDataTable from "./BaseDataTable";

export default BaseDataTable;
